var mydate = new Date()
export default mydate